<script setup lang="ts">
import { useAppStore } from '@/stores/app'
import { useTr } from '@/composables/useTr'

const app = useAppStore()
const { tr } = useTr()
</script>

<template>
  <aside class="monitor-sub-nav">
    <div class="ssn-header">{{ tr('监控规则', 'Monitor Rules') }}</div>
    <div class="ssn-item" :class="{ active: app.monitorFilter === 'all' }" @click="app.monitorFilter = 'all'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /></svg></span>
      <span style="flex:1;">{{ tr('全部规则', 'All Rules') }}</span>
      <span class="badge num">4</span>
    </div>
    <div class="ssn-item" :class="{ active: app.monitorFilter === 'active' }" @click="app.monitorFilter = 'active'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-low); margin-right:2px;" />
      <span style="flex:1;">{{ tr('已启用', 'Active') }}</span>
      <span class="badge num">0</span>
    </div>
    <div class="ssn-item" :class="{ active: app.monitorFilter === 'draft' }" @click="app.monitorFilter = 'draft'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--text-faint); margin-right:2px;" />
      <span style="flex:1;">{{ tr('未启 / 示例', 'Inactive / Demo') }}</span>
      <span class="badge num">4</span>
    </div>
    <div class="ssn-header" style="padding-top:14px;">{{ tr('推送通道', 'Push Channels') }}</div>
    <div class="ssn-item" :class="{ active: app.monitorFilter === 'feishu' }" @click="app.monitorFilter = 'feishu'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /></svg></span>
      <span style="flex:1;">{{ tr('飞书', 'Feishu') }}</span>
      <span class="badge num">—</span>
    </div>
    <div class="ssn-item" :class="{ active: app.monitorFilter === 'telegram' }" @click="app.monitorFilter = 'telegram'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path d="M21.5 4.5L2.5 12.4l6 2.3 2.3 6L21.5 4.5z" /></svg></span>
      <span style="flex:1;">Telegram</span>
      <span class="badge num">—</span>
    </div>
    <div class="ssn-item" :class="{ active: app.monitorFilter === 'email' }" @click="app.monitorFilter = 'email'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path d="M4 4h16v16H4zM4 4l8 8 8-8" /></svg></span>
      <span style="flex:1;">{{ tr('邮件', 'Email') }}</span>
      <span class="badge num">—</span>
    </div>
    <div class="ssn-header" style="padding-top:14px;">{{ tr('订阅状态', 'Subscription') }}</div>
    <div class="ssn-item" style="background:var(--panel-soft);" @click="app.proModal = true">
      <span class="ssn-icon"><svg fill="none" stroke="var(--pro-lock)" stroke-width="1.8" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0110 0v4" /></svg></span>
      <span style="flex:1;">{{ tr('解锁 Pro', 'Unlock Pro') }}</span>
      <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
    </div>
  </aside>
</template>
